import { Box, Typography, TableCell, TableRow } from "@mui/material";
import { Favorite } from "@mui/icons-material";
import { stylesCoinRow as styles } from "./stylesCoinRow";
import BullSvg from "../../../../assets/svg/BullSvg";
import BearSvg from "../../../../assets/svg/BearSvg";
import fallbackImage from "@/assets/image/fallback.png";
import { useGetCompanyLogoQuery } from "@/store/api/trendingStocksApi";
import { useNavigate } from "react-router-dom";
import { navigateWithParams } from "@/helpers/navigation";
import theme from "@/theme";

interface CoinRowProps {
  coin: {
    Icon: React.ElementType;
    name: string;
    symbol: string;
    change: number;
    sentiment: number;
    post: string;
    likes: string;
    percent: number;
  };
  queryParams?: Record<string, any>;
  blurred?: boolean;
}

export const CoinRow = ({ coin, queryParams, blurred = false }: CoinRowProps) => {
  const { name, symbol, change, sentiment, likes, post, percent } = coin;
  const { data: logoUrl } = useGetCompanyLogoQuery(symbol);
  const navigate = useNavigate();
  const isPositive = sentiment > 0;
  const color =
    sentiment > 0
      ? theme.palette.custom.secondaryGreen
      : sentiment < 0
        ? theme.palette.custom.secondaryRed
        : theme.palette.custom.blueGray600;

  const ChangeColor =
    change > 0 ? theme.palette.custom.secondaryGreen : theme.palette.custom.secondaryRed;

  const SentimentIcon = isPositive ? BullSvg : BearSvg;
  const handleClick = () => {
    if (blurred) return;
    navigateWithParams(navigate, "stock", queryParams, symbol);
  };
  return (
    <TableRow
      sx={{
        ...styles.coinRow,
        ...(blurred && {
          filter: "blur(4px)",
          userSelect: "none",
          pointerEvents: "none",
        }),
      }}
      onClick={handleClick}
    >
      <Box sx={styles.nameCellBox}>
        <Box sx={styles.icon}>
          <img
            src={"https://eodhd.com/" + logoUrl || fallbackImage}
            alt={symbol}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "50%",
              border: "1px solid #E4E7E9",
            }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = fallbackImage;
            }}
          />
        </Box>

        <Box sx={styles.textBox}>
          <Typography sx={styles.nameText} noWrap>
            {name}
          </Typography>
          <Typography sx={styles.symbolText} noWrap>
            {symbol}{" "}
            <span style={{ color: ChangeColor }}>
              {change < 0 ? `-$${Math.abs(change).toFixed(2)}` : `+$${change.toFixed(2)}`} (
              {percent < 0 ? percent * -1 : percent}%)
            </span>
          </Typography>
        </Box>
      </Box>

      <TableCell sx={styles.tableCell}>
        <Typography sx={styles.postsText}>{post}</Typography>
      </TableCell>

      <TableCell sx={styles.tableCell}>
        <Box sx={styles.likeBox}>
          <Favorite sx={{ mr: 1 }} fontSize="small" />
          <Typography sx={styles.likeText}>{likes}</Typography>
        </Box>
      </TableCell>

      <TableCell sx={styles.tableCell}>
        {/* {sentiment != 0 && ( */}
        <Box sx={styles.sentimentBox(color)}>
          <Typography sx={{ marginLeft: sentiment != 0 ? "0" : "15px" }}>
            {sentiment > 0 && sentiment != 0
              ? "+" + sentiment.toFixed(1)
              : sentiment != 0
                ? sentiment.toFixed(1)
                : sentiment}
          </Typography>
          {sentiment != 0 && (
            <Box sx={styles.sentimentIconBox}>
              <SentimentIcon />
            </Box>
          )}
        </Box>
        {/* )} */}
      </TableCell>
    </TableRow>
  );
};
